export default __webpack_public_path__ + "static/media/eight.5f6bd438.svg";